import { deleteHours, editSummary } from '../../../../logic/requests/students';

export const handleSubmit = (id, data, defaultValues, onSubmit) => {
    const toSend = Object.entries(data).reduce((out, [key, val]) => {
        if (defaultValues[key] !== val) out[key] = val;
        return out;
    }, {});
    if (!Object.keys(toSend).length) {
        console.log('handleSubmit', 'noChanges');
        return onSubmit?.();
    }
    if (toSend.hours) {
        toSend.hours = toSend.hours.replace(',', '.');
        toSend.half = toSend.hours === '0.5' ? 1 : 0;
        const int = parseInt(toSend.hours);
        if (isNaN(toSend.hours)) {
            console.warn('handleSubmit', 'invalidValue', 'toSend.hours', toSend.hours, int);
            return;
        }
        toSend.hours = int;
    }
    toSend.price = toSend.price?.replace(',', '.');
    toSend.price_trainer = toSend.price_trainer?.replace(',', '.');

    if (!Object.keys(toSend).length) return onSubmit?.();

    editSummary(id, toSend)
        .then((res) => {
            onSubmit?.(res);
        })
        .catch((err) => {
            console.error('editSummary', err);
        });
};

export const handleDelete = (
    id,
    isAdmin,
    onSuccess,
    confirmPopup,
    setConfirmPopup,
    reason,
    setTextareaError
) => {
    if (!confirmPopup) setConfirmPopup(true);

    if (confirmPopup) {
        if (!isAdmin && !reason) {
            setTextareaError('Podaj powód');

            return;
        }

        deleteHours(id, reason)
            .then(() => {
                onSuccess?.();
            })
            .catch((err) => {
                console.error('handleDelete', err);
            });
    }
};
